// extracted by mini-css-extract-plugin
export default {"heading":"Fz-z","corrected":"Gz-z","redirectVerbiageContainer":"Hz-z","redirectVerbiageText":"Iz-z"};